import React, {Component} from 'react';

export default class SystemError extends Component {

    render() {
        return(
            <main id="main_container" className="container-fluid">
                <div className="row">
                    <div className="col text-center mt-2">
                        <h1 className="h4 text-body mb-2">System error</h1>
                        {this.props.children}
                    </div>
                </div>
            </main>
        )
    }
}
